import { ReactNode } from "react";
import { Alert, AlertDescription, AlertTitle } from "@akuna/ui";
import { AlertCircle } from "lucide-react";
import { useHasPermissionSync } from "@/hooks/usePermissions";

interface PermissionGuardProps {
  resource: string;
  action?: "view" | "create" | "edit" | "delete";
  children: ReactNode;
  fallback?: ReactNode;
  showAlert?: boolean;
}

export function PermissionGuard({
  resource,
  action = "view",
  children,
  fallback,
  showAlert = true,
}: PermissionGuardProps) {
  const { hasPermission, isLoading } = useHasPermissionSync(resource, action);

  if (isLoading) {
    return null; // Or a loading spinner if preferred
  }

  if (!hasPermission) {
    if (fallback) {
      return <>{fallback}</>;
    }

    if (showAlert) {
      return (
        <Alert variant="danger">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Acesso Negado</AlertTitle>
          <AlertDescription>
            Você não tem permissão para acessar esta funcionalidade.
          </AlertDescription>
        </Alert>
      );
    }

    return null;
  }

  return <>{children}</>;
}

